import { motion } from "framer-motion";
import asesoria from "../img/social/zoom-logo.png";
import escribenos from "../img/social/wha-logo.png";
import what from "../img/what.png";

import zoom from "../img/zoom.png";
import Floating from "../components/Floating";

function PageContacto() {
  return (
    <>
      <div className="lightbluebg icon50 fonsize14 margin ">
        <div>
          <center>
            <div className="padding2 layout8">
              <h4>
                Conéctate con nosotros y recibe{" "}
                <b> asesoría virtual personalizada</b>
              </h4>
            </div>
            <motion.div
              className="social"
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.1,
                },
              }}
            >
              <img src={asesoria} alt="utpl"></img>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://cedia.zoom.us/j/89419717339"
              >
                <h3> Asesoría virtual </h3>
                <p>
                  <b> utpl.edu.ec/zoom</b>
                </p>
              </a>
            </motion.div>
     
            <motion.div
              className="social margin"
              initial={{ x: -50, opacity: 0 }}
              whileInView={{
                x: 0,
                opacity: 1,
                transition: {
                  delay: 0.1,
                },
              }}
            >
              <img src={escribenos} alt="utpl"></img>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://wa.me/593999565400"
              >
                <h3>WhatsApp</h3>
                <p>
                  <b>utpl.edu.ec/wa</b>
                </p>
                <p>0999565400</p>
              </a>
            </motion.div>
          </center>
          <br></br>
        </div>
      </div>
    </>
  );
}

export default PageContacto;
